import { render, staticRenderFns } from "./PreferencePage.vue?vue&type=template&id=db2fa2e4&scoped=true"
import script from "./PreferencePage.vue?vue&type=script&lang=js"
export * from "./PreferencePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2fa2e4",
  null
  
)

export default component.exports